export const CREDENTIAL_ALLOWED_PATTERN = /^[A-Za-z0-9_]+$/;

export const USERNAME_CHARACTER_ERROR =
  'Kullanıcı adı yalnızca İngilizce harfler, rakamlar ve alt tire (_) içerebilir.';

export const PASSWORD_CHARACTER_ERROR =
  'Şifre yalnızca İngilizce harfler, rakamlar ve alt tire (_) içerebilir.';

export const isCredentialValueAllowed = (value) => (
  CREDENTIAL_ALLOWED_PATTERN.test(String(value ?? ''))
);

export const hasInvalidCredentialCharacters = (value) => {
  const text = String(value ?? '');
  return text.length > 0 && !isCredentialValueAllowed(text);
};
